import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Banner.propTypes = {
  sx: PropTypes.object
};

export default function Banner({ sx }) {
  return <Box component="img" src="/static/bannerrmbg.png" sx={{ width: 400, height: 150, ...sx }} />;
}
